import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
interface TestimonialCardProps {
  name: string;
  role: string;
  content: string;
  image?: string;
  delay?: number;
}
export function TestimonialCard({
  name,
  role,
  content,
  image,
  delay = 0
}: TestimonialCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay,
    duration: 0.5
  }} className="bg-zinc-900 border border-zinc-800 p-6 rounded-xl hover:border-zinc-700 transition-colors" data-id="element-218">
      <div className="flex gap-1 mb-4" data-id="element-219">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-yellow-500 text-yellow-500" data-id="element-220" />)}
      </div>

      <p className="text-gray-300 mb-6 text-sm leading-relaxed" data-id="element-221">"{content}"</p>

      <div className="flex items-center gap-3" data-id="element-222">
        <div className="w-10 h-10 rounded-full bg-zinc-800 flex items-center justify-center border border-zinc-700 overflow-hidden" data-id="element-223">
          {image ? <img src={image} alt={name} className="w-full h-full object-cover" data-id="element-224" /> : <span className="text-yellow-500 font-bold text-lg" data-id="element-225">
              {name.charAt(0)}
            </span>}
        </div>
        <div data-id="element-226">
          <p className="text-white font-bold text-sm" data-id="element-227">{name}</p>
          <p className="text-zinc-500 text-xs" data-id="element-228">{role}</p>
        </div>
      </div>
    </motion.div>;
}